
import React from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { FileCheck, FileText } from 'lucide-react';

const FilingsTab = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between mb-4">
        <div className="w-1/3">
          <Input placeholder="Search compliances..." />
        </div>
        <div>
          <Button className="mr-2">
            <FileCheck className="mr-2 h-4 w-4" />
            Add Compliance Task
          </Button>
          <Button variant="outline">
            <FileText className="mr-2 h-4 w-4" />
            Export Report
          </Button>
        </div>
      </div>
      
      <Card>
        <CardContent className="p-0">
          <div className="border-b p-4">
            <div className="flex justify-between items-center">
              <div className="flex items-center">
                <FileCheck className="h-4 w-4 mr-2 text-primary" />
                <div>
                  <h3 className="font-medium">Annual Return (MGT-7) Filing</h3>
                  <p className="text-sm text-muted-foreground">Due within 60 days from AGM date</p>
                </div>
              </div>
              <Badge>Due in 14 days</Badge>
            </div>
          </div>
          <div className="border-b p-4">
            <div className="flex justify-between items-center">
              <div className="flex items-center">
                <FileCheck className="h-4 w-4 mr-2 text-primary" />
                <div>
                  <h3 className="font-medium">Board Meeting Notice</h3>
                  <p className="text-sm text-muted-foreground">7 days prior to meeting date</p>
                </div>
              </div>
              <Badge variant="outline">Recurring</Badge>
            </div>
          </div>
          <div className="border-b p-4">
            <div className="flex justify-between items-center">
              <div className="flex items-center">
                <FileCheck className="h-4 w-4 mr-2 text-primary" />
                <div>
                  <h3 className="font-medium">Annual Financial Statement Filing (AOC-4)</h3>
                  <p className="text-sm text-muted-foreground">Within 30 days of AGM</p>
                </div>
              </div>
              <Badge>Due in 25 days</Badge>
            </div>
          </div>
          <div className="p-4">
            <div className="flex justify-between items-center">
              <div className="flex items-center">
                <FileCheck className="h-4 w-4 mr-2 text-primary" />
                <div>
                  <h3 className="font-medium">Annual MSME Return</h3>
                  <p className="text-sm text-muted-foreground">Half-yearly filing for MSME payments</p>
                </div>
              </div>
              <Badge className="bg-green-100 text-green-800">Completed</Badge>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default FilingsTab;
